import ReferralCodeView from "./ReferralCodeView";
export default ReferralCodeView;